// extracted by mini-css-extract-plugin
module.exports = {"policyDocsSection":"policyDocsSection_policyDocsSection__gJiud","subtitle":"policyDocsSection_subtitle__wIty_","accordion":"policyDocsSection_accordion___AYjL"};